/**
 * Bernard Miniatures — filtres de collection.
 *
 * Horizon fournit déjà la mécanique (rendu de section, historique,
 * préchargement). Ce script n'ajoute que ce qui manque à une liste de 250
 * marques : une recherche interne, un décalage correct sous l'en-tête collant,
 * et le nombre de résultats à côté de la barre.
 *
 * Tout est ré-appliqué après chaque rendu de section, puisque Horizon remplace
 * le contenu de la grille et des facettes.
 */

const READY_ATTR = 'data-bm-facets-ready';

function settings() {
  const el = document.querySelector('[data-bm-facets-config]');
  if (!el) return null;
  try {
    return JSON.parse(el.getAttribute('data-bm-facets-config'));
  } catch {
    return null;
  }
}

/* ---------------------------------------------------------------- position */

function stickyOffset() {
  const header = document.querySelector('#header-component');
  if (!header) return 0;
  // La place réellement occupée en haut de fenêtre à cet instant. Tant que la
  // barre n'est pas collée, la valeur n'a aucun effet visible ; quand elle le
  // devient, l'en-tête est épinglé et la mesure s'est stabilisée.
  return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
}

function applyOffset() {
  document.documentElement.style.setProperty('--bm-fc-top', `${stickyOffset()}px`);
}

/* ------------------------------------------------------- recherche interne */

function buildSearch(panel, threshold, i18n) {
  const list = panel.querySelector('.facets__inputs-list');
  if (!list) return;
  const items = [...list.querySelectorAll('.facets__inputs-list-item')];
  if (items.length < threshold) return;

  const wrap = document.createElement('div');
  wrap.className = 'bm-facets__search';
  wrap.innerHTML =
    '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
    '<circle cx="9" cy="9" r="6.25" stroke="currentColor" stroke-width="1.6"/>' +
    '<path d="m13.6 13.6 3.65 3.65" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>';

  // Les libellés viennent des fichiers de langue, via la config posée par le
  // bloc `filters` : ce champ est construit en JavaScript, il n'a pas de Liquid
  // à lui. `%count%` est le jeton laissé par le filtre `t`.
  const searchLabel = String(i18n.search || '').replace('%count%', items.length);

  const input = document.createElement('input');
  input.type = 'search';
  input.autocomplete = 'off';
  input.placeholder = searchLabel;
  input.setAttribute('aria-label', searchLabel);
  wrap.appendChild(input);

  const empty = document.createElement('p');
  empty.className = 'bm-facets__empty';
  empty.hidden = true;
  empty.textContent = i18n.empty || '';

  list.parentElement.insertBefore(wrap, list);
  list.parentElement.insertBefore(empty, list.nextSibling);

  // « Voir plus » masque une partie de la liste : la recherche doit fouiller
  // tout le contenu, pas seulement ce qui est visible.
  const showMore = panel.querySelector('.show-more__button');

  input.addEventListener('input', () => {
    const term = input.value.trim().toLowerCase();
    if (term && showMore && showMore.getAttribute('aria-expanded') === 'false') {
      showMore.click();
    }
    let visible = 0;
    for (const item of items) {
      const text = item.textContent.toLowerCase();
      const match = !term || text.includes(term);
      item.style.display = match ? '' : 'none';
      if (match) visible++;
    }
    empty.hidden = visible > 0;
    if (showMore) showMore.style.display = term ? 'none' : '';
  });

  // Ne pas laisser la frappe fermer le panneau ou cocher une case.
  input.addEventListener('keydown', (event) => event.stopPropagation());
}

/* ---------------------------------------------------- nombre de résultats */

function showResultCount(config) {
  if (!config || !config.results || !config.count) return;
  const bar = document.querySelector('.facets--horizontal .facets__form-wrapper');
  if (!bar || bar.querySelector('.bm-facets__results')) return;
  const el = document.createElement('span');
  el.className = 'bm-facets__results';
  el.setAttribute('role', 'status');
  el.textContent = config.count;
  bar.appendChild(el);
}

/* ------------------------------------------------------------------ setup */

function setup() {
  const config = settings();
  applyOffset();

  if (config && config.sticky) {
    document.body.classList.add('bm-facets-sticky');
  }

  const threshold = (config && config.searchFrom) || 12;
  const i18n = (config && config.i18n) || {};
  for (const panel of document.querySelectorAll('.facets__panel')) {
    if (panel.hasAttribute(READY_ATTR)) continue;
    panel.setAttribute(READY_ATTR, '');
    buildSearch(panel, threshold, i18n);
  }

  showResultCount(config);
}

function boot() {
  setup();

  // Horizon remplace la grille et les facettes après chaque filtrage : il faut
  // re-greffer la recherche sur les panneaux fraîchement rendus.
  const host = document.querySelector('.product-grid-container') || document.body;
  const observer = new MutationObserver(() => {
    clearTimeout(boot.timer);
    boot.timer = setTimeout(setup, 60);
  });
  observer.observe(host, { childList: true, subtree: true });

  window.addEventListener('resize', applyOffset, { passive: true });
  window.addEventListener('scroll', applyOffset, { passive: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
